export default function ClientsMarquee() {
  const clientImage = "https://public.readdy.ai/ai/img_res/8baa0146-639b-4c90-b1c7-bf9fdf06708d.png";

  return (
    <section className="bg-background-50 py-12 md:py-16 border-y border-background-200/60">
      <div className="w-full px-4 md:px-8 lg:px-16 mb-8 md:mb-10">
        <div className="max-w-7xl mx-auto text-center">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-secondary-100 text-secondary-700 text-xs font-medium mb-4">
            <i className="ri-shield-star-line text-sm w-4 h-4 flex items-center justify-center" />
            Confían en Nosotros
          </div>
          <h3 className="font-heading text-xl md:text-2xl font-bold text-foreground-950">
            Nuestros <span className="text-primary-500">Clientes</span>
          </h3>
        </div>
      </div>

      <div className="overflow-hidden">
        <div className="flex items-center animate-marquee whitespace-nowrap">
          <img
            src={clientImage}
            alt="Shell, ZIMMIT, CLARIANT, NORINCO, CNBM - Clientes de RESINVENCA RESINAS DE VENEZUELA C.A."
            className="h-20 md:h-24 w-auto object-contain inline-block flex-shrink-0"
          />
          <img
            src={clientImage}
            alt="Shell, ZIMMIT, CLARIANT, NORINCO, CNBM - Clientes de RESINVENCA RESINAS DE VENEZUELA C.A."
            className="h-20 md:h-24 w-auto object-contain inline-block flex-shrink-0"
          />
          <img
            src={clientImage}
            alt="Shell, ZIMMIT, CLARIANT, NORINCO, CNBM - Clientes de RESINVENCA RESINAS DE VENEZUELA C.A."
            className="h-20 md:h-24 w-auto object-contain inline-block flex-shrink-0"
          />
          <img
            src={clientImage}
            alt="Shell, ZIMMIT, CLARIANT, NORINCO, CNBM - Clientes de RESINVENCA RESINAS DE VENEZUELA C.A."
            className="h-20 md:h-24 w-auto object-contain inline-block flex-shrink-0"
          />
        </div>
      </div>
    </section>
  );
}